import { Component, OnInit } from '@angular/core';
import { RenegociacaoCartaoService } from '../renegociacao-cartao.service';
import { Divida, OfertaNegociacao, CustomerDebtRenegociationData } from 'src/app/shared/models/customer-debt-renegociation';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import jsPDF from 'jspdf';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BaseModalService } from 'src/app/shared/services/base-modal.service';
import { ContratarAcordoRequest } from '../contratar-acordo-request';
import { PerfilService } from 'src/app/perfil/perfil.service';
import { RenegociacaoCartaoLoggerService } from '../renegociacao-cartao-logger.service';
import { AcaoRenegociacaoCartaoLoggerEnum, CondicaoPropostaEnum } from 'src/app/shared/models/renegociacao-cartao-logger-service.model';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { AcordoResponse } from '../contratar-acordo-response';
import PerfilCliente from 'src/app/shared/models/perfil-cliente.model';
import { ServicoCartaoIndisponivelError } from 'src/app/shared/models/servico-cartao-indisponivel.error';
import { ToastService } from 'src/app/shared/toast';

@Component({
  selector: "app-aceitar-termos",
  templateUrl: "./aceitar-termos.component.html",
  styleUrls: ["./aceitar-termos.component.scss"],
})
export class AceitarTermosComponent implements OnInit {
  numeroCartaoMascarado: string;
  customerDebt: CustomerDebtRenegociationData;
  debt: Divida;
  ofertaAtual: OfertaNegociacao;
  aceitoBtn: boolean = false;
  titleTermos: string;
  textoTermos: string;
  textoTermosPDF: string;
  perfil: PerfilCliente;

  constructor(
    private router: Router,
    private perfilService: PerfilService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private renegociacaoCartaoService: RenegociacaoCartaoService,
    private baseModalService: BaseModalService,
    private loader: LoaderService,
    private renegociacaoCartaoLoggerService: RenegociacaoCartaoLoggerService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.titleTermos = `TERMOS E CONDIÇÕES`;
    this.textoTermos = `As condições anteriormente proposta são válidas apenas para esta renegociação realizada neste canal na data de ${this.datePipe.transform(
      Date.now(),
      "dd/MM/yyyy"
    )}. O desconto concedido somente será válido se o pagamento for feito em sua totalidade e até a data de vencimento. Caso não ocorra o pagamento, o acordo será quebrado e a cobrança retomada em sua totalidade. Ratificamos que devido a negociação dessa dívida, ocorrerá o cancelamento do seu cartão de crédito. Inclusive dos seus dependentes. Após o aceite desta proposta a sua negociação será processada e a reabilitação do seu CPF junto aos órgãos de proteção ao crédito (SPC/SERASA) ocorrerá em até 5 dias úteis após o primeiro pagamento realizado.
    Caso tenha dúvidas, por favor, entre em contato com a nossa Central de atendimento: 4004 1203 (Principais Capitais) ou 0800 979 0203 (demais regiões).
    <br><strong>Após o aceite não será mais possível cancelar essa proposta.</strong>`;

    this.textoTermosPDF = `As condições anteriormente proposta são válidas apenas para esta renegociação realizada neste canal na data de ${this.datePipe.transform(
      Date.now(),
      "dd/MM/yyyy"
    )}. O desconto concedido somente será válido se o pagamento for feito em sua totalidade e até a data de vencimento. Caso não ocorra o pagamento, o acordo será quebrado e a cobrança retomada em sua totalidade. Ratificamos que devido a negociação dessa dívida, ocorrerá o cancelamento do seu cartão de crédito. Inclusive dos seus dependentes. Após o aceite desta proposta a sua negociação será processada e a reabilitação do seu CPF junto aos órgãos de proteção ao crédito (SPC/SERASA) ocorrerá em até 5 dias úteis após o primeiro pagamento realizado.
    Caso tenha dúvidas, por favor, entre em contato com a nossa Central de atendimento: 4004 1203 (Principais Capitais) ou 0800 979 0203 (demais regiões).
    Após o aceite não será mais possível cancelar essa proposta.`;

    this.handleOnInit();
  }

  async handleOnInit() {
    try {
      this.loader.start();
      this.customerDebt = await this.renegociacaoCartaoService.buscarDadosRenegociacaoCartao();
      this.debt = await this.renegociacaoCartaoService.debtAtual();
      this.numeroCartaoMascarado = this.mascararNumeroCartao(this.debt);
      this.ofertaAtual = await this.renegociacaoCartaoService.ofertaEscolhida();
    } catch (error) {
      if (error instanceof ServicoCartaoIndisponivelError) {
        this.toast.show({ type: 'error', title: 'Serviço temporariamente indisponível.', text: 'Por favor, tente novamente mais tarde.' })
      } else {
        this.toast.show({ type: 'error', title: 'Erro ao buscar dados do acordo.', text: 'Tente novamente mais tarde.' });
      }
    } finally {
      this.loader.stop();
    }
  }

  mascararNumeroCartao(debt: Divida) {
    return debt.idCartao
      .replace(/^0+/, "")
      .replace(/^(\d{4})\d{8}(\d{4})$/, "$1.xxxx.xxxx.$2");
  }

  get customerData() {
    return this.renegociacaoCartaoService.dadosRenegociacaoCartao?.contato;
  }

  downloadTermo() {
    const doc = new jsPDF();
    const title = this.titleTermos;
    const text = this.textoTermosPDF;

    const marginLeft = 10;
    const marginRight = 10;
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = pageWidth - marginLeft - marginRight;

    doc.setFont("times", "normal");
    doc.setFontSize(12);
    doc.setFontSize(16);
    const titleWidth = doc.getTextWidth(title);
    doc.text(title, (pageWidth - titleWidth) / 2, 20);
    doc.setFontSize(12);
    const textLines = doc.splitTextToSize(text, textWidth);
    let y = 40;
    textLines.forEach((line) => {
      const words = line.split(" ");
      let lineString = "";
      let lineWidth = 0;

      for (let i = 0; i < words.length; i++) {
        const wordWidth = doc.getTextWidth(words[i] + " ");
        if (lineWidth + wordWidth < textWidth) {
          lineString += words[i] + " ";
          lineWidth += wordWidth;
        } else {
          const spaceWidth =
            (textWidth - lineWidth) / (lineString.split(" ").length - 1);
          const justifiedLine = lineString
            .split(" ")
            .join(" ".repeat(spaceWidth));

          doc.text(justifiedLine, marginLeft, y);
          y += 10;

          lineString = words[i] + " ";
          lineWidth = wordWidth;
        }
      }
      doc.text(lineString.trim(), marginLeft, y);
      y += 10;
    });

    doc.save("TERMOS_E_CONDICOES.pdf");
  }

  async cancelarContratacao() {
    const result = await this.baseModalService
      .showConfirmationModal({
        text: "Tem certeza de que deseja <strong>cancelar</strong> a contratação?",
        confirmBtnText: "Sim",
        deniedBtnText: "Não cancelar",
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.router.navigateByUrl(
        "/portal/renegociacao/cartao/lista-cartoes/propostas"
      );
    }
  }

  async aceitarTermos() {
    try {
      this.loader.start();
      const contratoReq = await this.preencherDadosAcordo();
      const contratoResponse = await this.renegociacaoCartaoService.enviarAcordo(contratoReq);

      this.router.navigateByUrl("/portal/renegociacao/cartao/lista-cartoes/propostas/checkout/boleto");
      this.enviarLogConfirmarAcordo(contratoResponse);
    } catch (error) {
      if (error instanceof ServicoCartaoIndisponivelError) {
        this.toast.show({ type: 'error', title: 'Serviço temporariamente indisponível.', text: 'Por favor, tente novamente mais tarde.' })
      } else {
        this.toast.show({ type: 'error', title: 'Erro ao confirmar acordo.', text: 'Tente novamente mais tarde.' });
      }
    } finally {
      this.loader.stop();
    }
  }

  async preencherDadosAcordo(): Promise<ContratarAcordoRequest> {
    this.perfil = await this.perfilService.getPerfil();
    return {
      dataAcordo: new Date().toISOString(),
      idClienteBradesco: this.customerData.identidade.idContato.toString(),
      idDividaBradesco: this.debt.idDividaBradesco.toString(),
      idCartao: this.debt.idCartao.toString(),
      dataPrimeiroAtraso: this.debt.dataPrimeiroAtraso,
      valorDivida: this.debt.valorDivida,
      valorDividaAtualizada: this.debt.valorDividaAtualizada,
      idOferta: this.ofertaAtual.idOferta.toString(),
      valorAcordo: this.ofertaAtual.valorAcordo,
      plano: this.ofertaAtual.plano,
      tipoPlano:
        this.ofertaAtual.plano === 1 ? "A_VISTA" : "PARCELADO",
      valorParcela: this.ofertaAtual.valorParcela,
      valorEntrada: this.ofertaAtual.valorEntrada,
      dataVencimentoEntrada: this.customerDebt.dividasCliente[0].agendamentosPromessa[0].dataVencimentoEntrada,
      email: this.perfil?.email ? this.perfil.email : null,
      telefone: this.perfil?.celular ? this.perfil.celular : this.perfil?.telefone,
      nomeProduto: this.debt.nomeProduto,
    };
  }

  enviarLogAceiteTermos() {
    this.renegociacaoCartaoLoggerService.enviarLogRenegociacaoCartao({
      actionLogger: AcaoRenegociacaoCartaoLoggerEnum.CARTAO_BRADESCO_ACEITE_PROPOSTA_ACTION,
      cartao: this.debt.idCartao,
      dividaId: this.debt.idDividaBradesco,
      dadoPropostaEscolhida: {
        condicao: this.ofertaAtual.plano > 1 ? CondicaoPropostaEnum.PARCELADO : CondicaoPropostaEnum.AVISTA,
        dataEntrada: this.debt.dataNegociacao,
        quantidadeParcelas: this.ofertaAtual.plano - 1,
        valorEntrada: this.ofertaAtual.valorEntrada,
        valorParcelas: this.ofertaAtual.valorParcela,
        valorTotalPlano: this.ofertaAtual.valorAcordo,
      }
    })
  }

  enviarLogConfirmarAcordo(acordoEfetivado: AcordoResponse) {
    this.renegociacaoCartaoLoggerService.enviarLogRenegociacaoCartao({
      actionLogger: AcaoRenegociacaoCartaoLoggerEnum.CARTAO_BRADESCO_CONFIRMAR_ACORDO_ACTION,
      cartao: this.debt.idCartao,
      dividaId: this.debt.idDividaBradesco,
      acordoId: acordoEfetivado?.idAcordo ?? null,
      dadoAcordo: {
        condicao: this.ofertaAtual.plano > 1 ? CondicaoPropostaEnum.PARCELADO : CondicaoPropostaEnum.AVISTA,
        valorTotalPlano: this.ofertaAtual.valorAcordo,
        dataEntrada: this.debt.dataNegociacao,
        valorEntrada: this.ofertaAtual.valorEntrada,
        valorParcelas: this.ofertaAtual.valorParcela,
        linhaDigitavel: acordoEfetivado.parcelas[0].linhaDigitavel,
        codigoBarras: acordoEfetivado.parcelas[0].codigoBarras,
        email: this.perfil?.email ? this.perfil.email : null,
        celular: this.perfil?.celular ? this.perfil.celular : this.perfil?.telefone,
        firstDefaultDate: this.debt.dataPrimeiroAtraso,
        quantidadeParcelas: this.ofertaAtual.plano - 1
      }
    });
  }

  confirmarLeituraTermosLog() {
    if(this.aceitoBtn) {
      this.renegociacaoCartaoLoggerService.enviarLogRenegociacaoCartao({
        actionLogger:
          AcaoRenegociacaoCartaoLoggerEnum.CARTAO_BRADESCO_ACEITE_PROPOSTA_ACTION,
        cartao: this.debt.idCartao,
        dividaId: this.debt.idDividaBradesco,
        dadoPropostaEscolhida: {
          condicao:
            this.ofertaAtual.plano > 1
              ? CondicaoPropostaEnum.PARCELADO
              : CondicaoPropostaEnum.AVISTA,
          dataEntrada: this.debt.dataNegociacao,
          quantidadeParcelas: this.ofertaAtual.plano - 1,
          valorEntrada: this.ofertaAtual.valorEntrada,
          valorParcelas: this.ofertaAtual.valorParcela,
          valorTotalPlano: this.ofertaAtual.valorAcordo,
        },
      });
    }
  }
}
